<template>
  <AccordionPanel :value="panelValue" :disabled="disabled">
    <AccordionHeader>
      <slot name="header">{{ header }}</slot>
    </AccordionHeader>
    <AccordionContent>
      <slot />
    </AccordionContent>
  </AccordionPanel>
</template>

<script>
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";

let tabCounter = 0;

export default {
  name: "AccordionTab",
  components: { AccordionPanel, AccordionHeader, AccordionContent },
  props: {
    header: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    panelValue() {
      if (this.value != null) return this.value;
      if (this.header) return this.header;
      return `accordion-tab-${this._uid || ++tabCounter}`;
    },
  },
};
</script>
